
export class CloseDialog<T> {
    constructor (public cancelButtonClicked = false,
                 public success = false,
                 public payload: T = null,
                 public error: Error = null) {}
}
